<template>
  <div id="evaluate">
    <div class="ideas-to-evaluate-container" v-if="!emptyState">
      <div v-for="(idea, index) in ideasToEvaluateFiltered" :key="index">
        <idea-to-evaluate
          v-if="idea == ideasToEvaluateFiltered[randomIndex]"
          :idea="idea"
        ></idea-to-evaluate>
      </div>
    </div>

    <empty-state
      v-if="emptyState"
      v-bind:callToAction="callToAction"
      v-bind:image="emptyStateImage"
      v-bind:description="emptyStateDescription"
      v-bind:primary="true"
    ></empty-state>
  </div>
</template>

<script>
import bus from "../bus";

import IdeaToEvaluate from "./IdeaToEvaluate";
import EmptyState from "./EmptyState.vue";

import getAllIdeasToEvaluate from "../gql/ideas/getAllIdeasToEvaluate.gql";

export default {
  components: {
    IdeaToEvaluate,
    EmptyState,
  },
  data() {
    return {
      callToAction: "to remove",
      emptyStateDescription:
        "Congratulations! There are no ideas left to rate. Tip: Try creating some new ones.",
      emptyStateImage: "undraw_completed.svg",
      ideasToEvaluate: [],
      randomIndex: 0,
      randomIndexFlag: false,
    };
  },
  apollo: {
    $subscribe: {
      ideasToEvaluate: {
        query: getAllIdeasToEvaluate,
        variables() {
          return {
            user_id: this.userId,
            list_id_in: this.listIds,
          };
        },
        update: (data) => data.ideas,
        result(data) {
          this.ideasToEvaluate = data.data.ideas;
          bus.$emit("hide-loader");
        },
      },
    },
  },
  computed: {
    userId() {
      return this.$store.state.user.id;
    },
    emptyState() {
      return this.ideasToEvaluateFiltered.length == 0;
    },
    ideasToEvaluateFiltered() {
      let ideasToEvaluateFiltered = [];

      for (let i = 0; i < this.ideasToEvaluate.length; i++) {
        if (this.ideasToEvaluate[i].evaluations.length == 0) {
          let ideaInfo = this.ideasToEvaluate[i];
          ideaInfo["lists"] = this.selectLists(this.ideasToEvaluate[i]);
          ideasToEvaluateFiltered.push(ideaInfo);
        }
      }

      this.changeIndex(ideasToEvaluateFiltered);

      return ideasToEvaluateFiltered;
    },
  },
  methods: {
    evaluateIdeaEvent: function () {
      bus.$on("idea-evaluated", (id) => {
        let newIdeasToEvaluate = JSON.parse(
          JSON.stringify(this.ideasToEvaluate)
        );
        for (let i = 0; i < newIdeasToEvaluate.length; i++) {
          if (newIdeasToEvaluate[i].id == id) {
            newIdeasToEvaluate.splice(i, 1);
            break;
          }
        }
        this.ideasToEvaluate = newIdeasToEvaluate;

        this.randomIndexFlag = false;
        this.changeIndex();
      });
    },
    selectLists: function (idea) {
      let selectedLists = [];
      let ideaLists = idea.ideas_lists;
      for (let i = 0; i < ideaLists.length; i++) {
        if (ideaLists[i] && ideaLists[i].list.users_lists.length > 0) {
          selectedLists.push(ideaLists[i].list);
        }
      }
      return selectedLists;
    },
    changeIndex: function (ideasToEvaluateFiltered) {
      if (!ideasToEvaluateFiltered) {
        ideasToEvaluateFiltered = this.ideasToEvaluateFiltered;
      }

      if (!this.randomIndexFlag) {
        this.randomIndex = this.getRandomNumberWithSeed(
          0,
          ideasToEvaluateFiltered.length - 1,
          this.hashUuidToInteger(this.userId)
        );
        if (ideasToEvaluateFiltered.length > 0) {
          this.randomIndexFlag = true;
        }
      }
    },
    getRandomNumberWithSeed(min, max, seed) {
      if (typeof seed === "number") {
        // the initial seed
        Math.seed = seed;

        // in order to work 'Math.seed' must NOT be undefined,
        // so in any case, you HAVE to provide a Math.seed
        Math.seed = (Math.seed * 9301 + 49297) % 233280;
        var rand = Math.seed / 233280;
        return Math.floor(rand * (max - min + 1) + min);
      } else {
        rand = Math.floor(Math.random() * (max - min + 1)) + min;
      }
      return rand;
    },
    hashUuidToInteger(uuid, N) {
      const INIT_NUMBER = 271;

      if (uuid) {
        const x = uuid
          .split("-")
          .reduce((a, b) => a ^ Number.parseInt(b, 16), INIT_NUMBER);
        var result = arguments.length === 1 ? x : x % N;
        if (result < 0) {
          result = result * -1;
        }
        return result;
      } else {
        return 0;
      }
    },
  },
  beforeMount: function () {
    this.evaluateIdeaEvent();
  },
  props: {
    listIds: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

// #evaluate {
//   padding: 40px 30px;
// }
</style>